import { render, staticRenderFns } from "./SafetyRecommendationForm.vue?vue&type=template&id=28ce8b18"
import script from "./SafetyRecommendationForm.vue?vue&type=script&lang=js"
export * from "./SafetyRecommendationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports